import { cn } from "@lib/utils";

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
	rounded?: string;
};

/** Stack is a container component for arranging elements vertically or horizontally.
 * @prop direction - The direction of the stack
 * @prop spacing - Space between children (px). Default: 0
 * @prop divider - Element rendered between each child (e.g. a Divider)
 */
export const Image = ({ width, height, src, alt, className, style, rounded, ...props }: ImageProps) => (
	<picture style={{ width, height }}>
		<img
			width={width}
			height={height}
			src={src}
			alt={alt}
			className={cn(rounded, className)}
			style={style}
			{...props}
		/>
	</picture>
);

Image.displayName = "Image";
